import React from 'react';
import { Send, Globe } from 'lucide-react';

interface FooterProps {
  onOpenNetworkStatus: () => void;
}

const Footer: React.FC<FooterProps> = ({ onOpenNetworkStatus }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-8 mt-20 bg-black/60 backdrop-blur-xl z-10 relative">
      {/* Animated Glowing Top Border */}
      <div className="absolute top-0 left-0 w-full h-[1px]">
        {/* Base line */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent"></div>
        {/* Moving gradient glow */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-400/80 via-blue-500/80 to-purple-600/80 to-transparent blur-[2px] opacity-70 animate-gradient-x bg-[length:200%_200%]"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
        
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-gradient-to-br from-cyan-500 to-purple-600 rounded-md flex items-center justify-center font-bold text-xs text-white shadow-[0_0_15px_rgba(6,182,212,0.4)]">
            Z
          </div>
          <span className="text-gray-400 text-sm">© {currentYear} Zentix Nexus. All rights reserved.</span>
        </div>

        <div className="flex gap-6">
          <a 
            href="https://t.me/ZentixAdmin" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group flex items-center gap-2 text-sm text-gray-500 hover:text-cyan-400 transition-colors duration-300"
          >
            <Send size={14} className="group-hover:drop-shadow-[0_0_8px_rgba(6,182,212,0.8)] transition-all" />
            <span>Telegram Support</span>
          </a>
          <button 
            onClick={onOpenNetworkStatus}
            className="group flex items-center gap-2 text-sm text-gray-500 hover:text-purple-400 transition-colors duration-300 outline-none"
          >
            <Globe size={14} className="group-hover:drop-shadow-[0_0_8px_rgba(168,85,247,0.8)] transition-all" />
            <span>Network Status</span>
          </button>
        </div>

      </div>
    </footer>
  );
};

export default Footer;